import {Button, Col, Row} from "antd";
import {ConnectBankAccountBox} from "../../../../../components/payouts/v2/connect-bank-account";
import {StyledConnectBankAccountBoxWrapper} from "../../../../../components/payouts/v2/connect-bank-account/styles";
import {usePayoutSettingsContext} from "../../../../../components/payouts/v2/tabs/payout-settings-tab/context";
import {AccountDetailsForm} from "../../../../../components/payouts/v2/tabs/payout-settings-tab/form";
import {AccountDetailsOTPView} from "../../../../../components/payouts/v2/tabs/payout-settings-tab/otp-view";
import {IOnboardingStepProps} from "../../../i-step";

interface OnboardingAccountConnectionStepFlowProps extends IOnboardingStepProps {}

export function OnboardingAccountConnectionStepFlow({
  currentStep,
  updateStep,
}: OnboardingAccountConnectionStepFlowProps) {
  const {state} = usePayoutSettingsContext();
  // console.log({state});

  function handleView() {
    let content;
    switch (state.currentStep.currentView) {
      case "otp":
        content = <AccountDetailsOTPView />;
        break;
      case "form":
        content = <AccountDetailsForm />;
        break;
      default:
      case "initial":
        content = (
          <div>
            <ConnectBankAccountBox variant="onboarding" />
            <Row gutter={[16, 16]} style={{marginTop: "3.5rem"}}>
              <Col span={24} sm={8}>
                <Button
                  block
                  size="small"
                  type="default"
                  htmlType="button"
                  onClick={() => updateStep(1)}
                >
                  Back
                </Button>
              </Col>
              <Col span={24} sm={8}>
                <Button
                  onClick={() => updateStep(3)}
                  block
                  size="small"
                  type="primary"
                  htmlType="submit"
                >
                  Next
                </Button>
              </Col>
            </Row>
          </div>
        );
    }
    return content;
  }
  return (
    <StyledConnectBankAccountBoxWrapper>
      {handleView()}
    </StyledConnectBankAccountBoxWrapper>
  );
}
